<template>
  <div >
    <v-card  class="d-none d-sm-none d-md-block d-lg-block d-xl-block" rounded="0" elevation="0">
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12" sm="12" md="3" lg="3" class="mt-5">
            <v-card class="mx-auto pa-3"  variant="tonal" color="green">
              {{  getFooterDetails.header_content }}
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row no-gutters>
              <v-col cols="12" sm="12" md="2" lg="3">
                &nbsp;
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" class="d-flex">
                <img alt="Vue logo" :src="sparkImage" height="120" contain  class="mr-5"/>
                <img alt="Vue logo" :src="logoImage" height="120" contain  class="mr-5" />
                <img alt="Vue logo" :src="sparkImage" height="120" contain   />
              </v-col>
              <v-col cols="12" sm="12" md="2" lg="3">
                &nbsp;
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3">
            <div class="d-flex">
              <div>             
                <v-btn class="text-none" stacked variant="text" v-if="cartQty" @click="cartDialogue()">
                  <v-badge color="info" :content="cartQty">
                    <v-icon>mdi-cart-outline</v-icon>
                  </v-badge>
                </v-btn>
                <v-btn class="text-none" stacked variant="text" v-if="cartQty == ''">
                  <v-badge color="info" content="0+">
                    <v-icon>mdi-cart-outline</v-icon>
                  </v-badge>
                </v-btn>
              </div>
              <div>
                <v-btn variant="text" class="mt-5 ml-5">
                  <div> NET TOTAL : </div> ₹ {{ productSalesPrice }}
              </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card  class="d-block d-sm-block d-md-none d-lg-none d-xl-none" rounded="0" elevation="0">
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12" sm="12" md="12" lg="12" class="mb-3">
            <v-card class="mx-auto pa-3"  variant="tonal" color="green">
              {{  getFooterDetails.header_content }}
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12" class="d-flex justify-center">
            <img alt="Vue logo" :src="sparkImage" height="90" contain  class="mr-5"/>
                <img alt="Vue logo" :src="logoImage" height="90" contain  class="mr-5" />
                <img alt="Vue logo" :src="sparkImage" height="90" contain   />
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <div class="d-flex">
              <div>
                <v-btn class="text-none" stacked variant="text" v-if="cartQty" @click="cartDialogue()">
                  <v-badge color="info" :content="cartQty">
                    <v-icon>mdi-cart-outline</v-icon>
                  </v-badge>
                </v-btn>
                <v-btn class="text-none" stacked variant="text" v-if="cartQty == ''">
                  <v-badge color="info" content="0+">
                    <v-icon>mdi-cart-outline</v-icon>
                  </v-badge>
                </v-btn>
              </div>
              <div>
                <v-btn variant="text" class="mt-5">
                ₹ {{ productSalesPrice }}
              </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <div class="d-flex justify-center mb-6 bg-primary">
      <v-breadcrumbs :items="menus" divider="" class="d-none d-sm-none d-md-block d-lg-block d-xl-block" :max-items="5"></v-breadcrumbs>
      <div class="d-block d-sm-block d-md-none d-lg-none d-xl-none">
        <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer" ></v-app-bar-nav-icon> <span class="mt-5">Menu</span>
      </div>
    </div>


    <v-navigation-drawer
        v-model="drawer"
        temporary
        location="right"
      >
        <v-list-item
          :prepend-avatar="logoImage"
          
        ></v-list-item>

        <v-divider></v-divider>

        <!-- <v-list density="compact" nav>
          <v-list-item prepend-icon="mdi-view-dashboard" title="Home" value="home"></v-list-item>
          <v-list-item prepend-icon="mdi-forum" title="About" value="about"></v-list-item>
        </v-list> -->

        <v-list   :lines="false"    density="compact"  nav  v-for="(item, i) in menus"
            :key="i"
            :value="item">
          <v-list-item
            :href="item.href"
            color="primary"
            
          >
              <v-list-item-title  :to="item.href">{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>

      </v-navigation-drawer>

    <div  class="mt-n6 mx-auto">
      <v-carousel hide-delimiters height="auto" :show-arrows="false">
        <v-carousel-item  :src="homeImage" cover ></v-carousel-item>
      </v-carousel>
    </div>
 
    </div>

    
  </template>
   
  <style>
.top-bar {
  position: fixed;
  width: 100%;
  z-index: 111;
}
</style>
<script setup>
  import { ref } from 'vue'

  const drawer = ref(null)
</script>
  <script>
  // @ is an alias to /src

  //images
import logoImage from "../assets/logo.png";
import sparkImage from "../assets/spark.jpeg";
import homeImage from "../assets/home.jpg";

import {  mapGetters } from "vuex";
  
  export default {
    props: ['cartQty','productSalesPrice'],
    name: "HeaderMenu",
    data: () => ({
    logoImage: logoImage,
    homeImage: homeImage,
    sparkImage: sparkImage,
    menus: [
            {
              title: "Home",
              disabled: false,
              href: "home",
            },
            {
              title: "About",
              disabled: false,
              href: "about",
            },
            {
              title: "Product",
              disabled: false,
              href: "/",
            },
            {
              title: "Wholesale",
              disabled: false,
              href: "wholesale",
            },
            {
              title: "Giftbox",
              disabled: false,
              href: "giftbox",
            },
            {
              title: "Familypack",
              disabled: false,
              href: "familypack",
            },
            {
              title: "Safety Tips",
              disabled: false,
              href: "safetytips",
            },
            {
              title: "Contact",
              disabled: false,
              href: "contact",
            },
        ],
  }),

    computed: {
      ...mapGetters(["getFooterDetails"]),
    },
    created() {},
    methods: {
      cartDialogue(){
        console.log('enter');
        this.$emit("childEvent", { message: "Hello from child!" });
      }
    },
  };
  </script>